/** @jsx jsx */
import { Col, Container, Row } from 'react-bootstrap'
import { jsx } from '@emotion/react'
import { Link } from 'gatsby'

import LogoElosFooter from '../assets/images/lp/logotipo_bertoni_elos_footer.svg'
import imgMap from '../assets/images/lp/unidades/icons/mapa.svg';
import imgMapMobile from '../assets/images/lp/unidades/icons/mapaMobile.svg';
import {
  footerSection,
  social,
  logoFooter,
  itens,
  actionsImgIconsSocialFooter,
  mobileFooter,
} from '../assets/styles/Footer.styles'
import Instagram from '../assets/images/lp/icons/instagram-header.svg'
import Facebook from '../assets/images/lp/icons/facebook-header.svg'
import Youtube from '../assets/images/lp/icons/youtube-header.svg'
import Whatsapp from '../assets/images/lp/icons/Whatsapp.svg'
import InstagramMobile from '../assets/images/lp/icons/mobileIconsFooter/instagram-header.svg'
import FacebookMobile from '../assets/images/lp/icons/mobileIconsFooter/facebook-header.svg'
import YoutubeMobile from '../assets/images/lp/icons/mobileIconsFooter/youtube-header.svg'
import WhatsappMobile from '../assets/images/lp/icons/mobileIconsFooter/Whatsapp.svg'
const Footer = () => {
  return (
    <footer  >
      <Container css={footerSection}  fluid  >       
        <Row className="d-flex justify-content-center">
          
          <Col  
             lg={3}
             md={4}
             sm={12}

             style={{padding: 0,marginRight:0, display: 'flex', justifyContent: 'center'}}
          >
            <div css={logoFooter}>
              <Link to='/'><img src={LogoElosFooter} alt=' ' /></Link>
              
              <p className='pt-4'>A escola do ser íntegro, inteligente e conectado.</p>
            </div>
          </Col>
         
          <Col
           lg={1}
           md={1}
           sm={12}
          
            style={{ textAlign: 'justify', padding: 0, margin: 0, display: 'flex', justifyContent: 'flex-start' }}
          >
            <div >
            <Link to='/elos'><h4>Elos</h4></Link>
            </div>
          </Col>
          <Col
           lg={1}
           md={1}
           sm={12}
          
            style={{ textAlign: 'justify', padding: 0, margin: 0, display: 'flex', justifyContent: 'flex-start' }}
          >
            <div>
            <Link to='/origem'><h4 className='sobre'>Sobre nós</h4></Link>
            </div>
          </Col>
          <Col
           lg={2}
           md={2}
           sm={12}
         
            style={{ textAlign: 'justify', padding: 0, margin: 0, display: 'flex', justifyContent: 'center'}}
          >
            <div>
              <h4>Segmentos</h4>
              <div css={itens}>
                <Link className="segments" to={'/segmentos/#eduInfantil'}>Educação Infantil</Link>
                <br />
                <Link className="segments" to={'/segmentos/#efai'}>EFAI</Link>
                <br />
                <Link className="segments" to={'/segmentos/#efaf'}>EFAF</Link>
                <br />
                <Link className="segments" to={'/segmentos/#ensinoMedio'}>Ensino Médio</Link>
                <br />
                <Link className="segments" to={'/segmentos/#preVest'}>Pré-Vest</Link>
              </div>
            </div>
          </Col>
          <Col
           lg={2}
           md={2}
           sm={12}
       
            style={{ textAlign: 'justify', padding: 0, marginRight: 0, display: 'flex', justifyContent: 'center'}}
          >
            <div className='estrutura'>
              <h4>Unidades</h4>
              <div css={itens}>
                <div>
                  <img  src={imgMap} />
                  <Link className="unitsLinks" to='/unidadeCentro'>Centro, Medianeira</Link>
                </div>
                <div>
                  <img  src={imgMap} />
                  <Link className="unitsLinks" to='/unidadeEncantado'>Jardim Encantado, Medianeira</Link>
                </div>
                <div>
                  <img  src={imgMap} />
                  <Link className="unitsLinks" to='/unidadeBoulevard'>Boulevard, Foz do Iguaçu</Link>
                </div>
              </div>
            </div>
          </Col>
          {/* <Col
            // data-aos-offset='300'
            // data-aos='fade-down'
            // data-aos-easing='ease-in-out'
            lg={2}
            md={2}
            sm={12}
            style={{ textAlign: 'justify', padding: 0, margin: 0 , display: 'flex', justifyContent: 'center' }}
          >
            <div>
              <h4>Blog</h4>
              <div css={itens}>     
              <Link to='/'>Eventos</Link>
              <br />
              <Link to='/'>Notícias</Link>
              <br />
              <Link to='/'>Redes Sociais</Link>
              </div>
            </div>
          </Col> */}
          <Col
            lg={2}
            md={2}
            sm={12}
          >
            <div css={social}>
              <h4 className='ml-2'>Redes Sociais</h4>
              <div>
                <p style={{marginLeft:'12px'}}>Medianeira</p>
                <div className='iconsSocial'>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.instagram.com/bertoni.elos/" target="_blank"><img src={Instagram} /></a>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.facebook.com/bertonielos" target="_blank"><img src={Facebook} /></a>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.youtube.com/@rede_bertoni/featured" target="_blank"><img src={Youtube} /></a>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '6px'}} href="https://api.whatsapp.com/send/?phone=554588442900&text&type=phone_number&app_absent=0" target="_blank"><img src={Whatsapp} /></a>
                </div>
              </div>
              <div>
                <p style={{marginLeft:'12px'}}>Boulevard, Foz do Iguaçu</p>
                <div className='iconsSocial'>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.instagram.com/elos.boulevard/" target="_blank"><img src={Instagram} /></a>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.facebook.com/elos.boulevard" target="_blank"><img src={Facebook} /></a>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.youtube.com/@rede_bertoni/featured" target="_blank"><img src={Youtube} /></a>
                    <a css={actionsImgIconsSocialFooter} style={{marginLeft: '6px'}} href="https://api.whatsapp.com/send/?phone=554588424675&text&type=phone_number&app_absent=0" target="_blank"><img src={Whatsapp} /></a>
                </div>
              </div>
            </div>
                         
          </Col>
        </Row>
      </Container>
      <Container   fluid css={mobileFooter}>
          <Row>
              <Col>
                <div className='d-flex ml-0 flex-column align-items-start justify-content-start mt-5 mb-5 '>
                  <h5 style={{marginLeft: '12px'}} className='mb-0 mr-2' >Redes Sociais</h5>
                    <div className='pt-3'>
                        <p style={{marginLeft:'12px'}}>Medianeira</p>
                        <div className='iconsSocial'>
                            <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.instagram.com/bertoni.elos/" target="_blank"><img src={InstagramMobile} /></a>
                            <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.facebook.com/bertonielos" target="_blank"><img src={FacebookMobile} /></a>
                            <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.youtube.com/@rede_bertoni/featured" target="_blank"><img src={YoutubeMobile} /></a>
                            <a css={actionsImgIconsSocialFooter} style={{marginLeft: '6px'}} href="https://api.whatsapp.com/send/?phone=554588442900&text&type=phone_number&app_absent=0" target="_blank"><img src={WhatsappMobile} /></a>
                        </div>
                    </div>
                    <div className='pt-1'>
                      <p style={{marginLeft:'12px'}}>Boulevard, Foz do Iguaçu</p>
                      <div className='iconsSocial'>
                          <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.instagram.com/elos.boulevard/" target="_blank"><img src={InstagramMobile} /></a>
                          <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.facebook.com/elos.boulevard" target="_blank"><img src={FacebookMobile} /></a>
                          <a css={actionsImgIconsSocialFooter} style={{marginLeft: '12px'}}href="https://www.youtube.com/@rede_bertoni/featured" target="_blank"><img src={YoutubeMobile} /></a>
                          <a css={actionsImgIconsSocialFooter} style={{marginLeft: '6px'}} href="https://api.whatsapp.com/send/?phone=554588424675&text&type=phone_number&app_absent=0" target="_blank"><img src={WhatsappMobile} /></a>
                      </div>
                    </div>
                </div>
              </Col>
          </Row>
          <Row>
            <Col>
              <div style={{marginLeft: '12px'}} className='mb-5'>
              <Link  to='/elos'><h5>Elos</h5></Link>
              </div>
              <div style={{marginLeft: '12px'}} className='pt-4'>
              <Link className="segments" to='/origem'><h5>Sobre nós</h5></Link>
              </div>
            </Col>
            <Col
            >
              <div>
                <h5>Segmentos</h5>
                <div >
                  <Link className="segments" to={'/segmentos/#eduInfantil'}>Educação Infantil</Link>
                  <br />
                  <Link className="segments" to={'/segmentos/#efai'}>EFAI</Link>
                  <br />
                  <Link className="segments" to={'/segmentos/#efaf'}>EFAF</Link>
                  <br />
                  <Link className="segments" to={'/segmentos/#ensinoMedio'}>Ensino Médio</Link>
                  <br />
                  <Link className="segments" to={'/segmentos/#preVest'}>Pré-Vest</Link>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col fluid className='mt-4' >
              <div  style={{marginLeft: '12px'}}>
                <h5>Unidades</h5>
                <div >
                  <div className='d-flex align-items-center mb-3 mt-4'>
                    <img className='imgUnitsmonile' src={imgMapMobile} />
                    <Link className="unitsLinksMobile" to='/unidadeCentro'>Centro, Medianeira</Link>
                  </div>
                  <div className='d-flex align-items-center mb-3 '>
                    <img className='imgUnitsmonile' src={imgMapMobile} />
                    <Link className="unitsLinksMobile" to='/unidadeEncantado'>Jardim Encantado, Medianeira</Link>
                  </div>
                  <div className='d-flex align-items-center mb-3 '>
                    <img className='imgUnitsmonile' src={imgMapMobile} />
                    <Link className="unitsLinksMobile" to='/unidadeBoulevard'>Boulevard, Foz do Iguaçu</Link>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
          <Col className='mt-5' >
              <div css={logoFooter}>
                <Link to='/'><img src={LogoElosFooter} alt=' ' /></Link>
                <p className='pt-0'>A escola do ser íntegro, inteligente e conectado.</p><br />
              </div>
            </Col>
          </Row>
        </Container>
    </footer>
  )
}

export default Footer
